module.exports = __webpack_public_path__ + "media/generate.1db6d96e.mp4";